import { Box, BoxProps, FormControlLabel, Radio, RadioProps, styled } from '@mui/material'
import React from 'react'

import { COLORS, COLORS_THEME } from '../../../constants/colors'
import { fontSize } from '../../../themes/themes'

interface RadioButtonProps {
  label: string
  value: string
  onClick: () => void
  currentValue: string
  textSize?: string
  fullWidth?: boolean
  noBorder?: boolean
  isDisabledSelectedBorder?: boolean
  isDisabled?: boolean
  textWeight?: string
  customWidth?: string
}

interface StyledBoxProps extends BoxProps {
  isSelected: boolean
  noBorder: boolean
  isDisabledSelectedBorder: boolean
}

interface StyledRadioProps extends RadioProps {
  textSize: string
  textWeight: string
}

const RadioButton = ({
  label,
  value,
  onClick,
  currentValue,
  fullWidth,
  noBorder = false,
  isDisabledSelectedBorder = false,
  textWeight = '500',
  customWidth = 'auto',
  textSize = fontSize.h5,
  isDisabled = false
}: RadioButtonProps) => {
  const isSelected = currentValue === value

  return (
    <StyledBox
      isSelected={isSelected}
      onClick={isDisabled ? undefined : onClick}
      width={fullWidth ? '100%' : customWidth}
      noBorder={noBorder}
      isDisabledSelectedBorder={isDisabledSelectedBorder}
    >
      <FormControlLabel
        label={label}
        checked={isSelected}
        disabled={isDisabled}
        control={
          <StyledRadio textSize={textSize} name={label} value={value} disabled={isDisabled} textWeight={textWeight} />
        }
      />
    </StyledBox>
  )
}

const StyledBox = styled(Box, {
  shouldForwardProp: (props) => props !== 'isSelected' && props !== 'noBorder' && props !== 'isDisabledSelectedBorder'
})<StyledBoxProps>(({ theme, isSelected, noBorder, isDisabledSelectedBorder }) => ({
  border: noBorder
    ? 'none'
    : `1px solid ${isSelected && !isDisabledSelectedBorder ? COLORS_THEME.primary : COLORS.grey300}`,
  textTransform: 'none',
  borderRadius: theme.spacing(2),
  padding: noBorder ? theme.spacing(0) : theme.spacing(2, 4),
  cursor: 'pointer',
  '& .MuiFormControlLabel-root .MuiRadio-root span .MuiSvgIcon-root': {
    color: isSelected ? COLORS_THEME.primary : COLORS.grey300
  }
}))

export const StyledRadio = styled(Radio, {
  shouldForwardProp: (props) => props !== 'textSize' && props !== 'textWeight'
})<StyledRadioProps>(({ theme, textSize, textWeight }) => ({
  '&.MuiRadio-root': {
    padding: 0,
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    whiteSpace: 'nowrap'
  },
  '&.MuiRadio-root:hover': {
    backgroundColor: 'transparent'
  },
  '& .MuiTouchRipple-root, & .MuiTouchRipple-root:hover': {
    width: theme.spacing(6),
    height: theme.spacing(6)
  },
  '& + .MuiTypography-root': {
    color: 'black',
    fontSize: textSize,
    fontWeight: textWeight,
    whiteSpace: 'nowrap'
  }
}))

export default RadioButton
